/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import {
  List,
  Modal,
  Icon,
  Divider,
  Image,
  Button,
  Label
} from 'semantic-ui-react';
import ModalAd from './ModalAd';
import Images from '../../assets/Images';
import './AdList.css';

class AdList extends Component {
  state = {
    showModalAd: false,
    currentAdSet: null,
    adToEdit: null,
    isDAA: false,
    objective: '',
    adSet: null,
    showRemoveAdFromPackageModal: false,
    possibleAdToRemoveId: null,
    currentSingleThumbnails: []
  };

  componentWillReceiveProps(nextProps) {
    const { currentSingleThumbnails } = this.props;
    const { currentSingleThumbnails: nextThumbnails } = nextProps;
    if (currentSingleThumbnails.length !== nextThumbnails.length) {
      this.setMatchingThumbnails(nextThumbnails);
      this.forceUpdate();
    }
  }

  onCloseModalAd = () => {
    this.setState({
      showModalAd: false,
      currentAdSet: null,
      adToEdit: null,
      possibleAdToRemoveId: null,
      isDAA: false
    });
  };

  openAdModal = (adSetId, ad, adset) => {
    const { campaigns } = this.props;
    const isDAA = adset.daaType === 'Retargeting' || adset.daaType === 'Broad';
    const { objective } = campaigns.find(
      (campaign) => campaign.id === adset.campaignId
    );
    this.setState({
      showModalAd: true,
      currentAdSet: adSetId,
      adToEdit: ad,
      isDAA,
      objective,
      adset
    });
  };

  addAd = (ad) => {
    const adToPush = ad;
    adToPush.adSetId = this.state.currentAdSet;
    this.props.addAd(adToPush);
    this.onCloseModalAd();
  };

  removeAd = (id) => {
    const { removeAd } = this.props;
    if (removeAd) removeAd(id);
  };

  removeAdFromPackage = () => {
    const { removeAd } = this.props;
    const { possibleAdToRemoveId } = this.state;
    if (removeAd) removeAd(possibleAdToRemoveId);
    this.onCloseModalAd();
  };

  toggleRemoveAdFromPackageModal = (id) => {
    this.setState((prevState) => ({
      ...prevState,
      showModalAd: true,
      possibleAdToRemoveId: id
    }));
  };

  editAd = (ad, adSetId, adset) => {
    this.openAdModal(adSetId, ad, adset);
  };

  checkValidAd = (ad) => {
    if (!ad) {
      return false;
    }

    const { ad: innerAd } = ad;
    if (!innerAd) {
      return false;
    }

    return true;
  };

  setMatchingThumbnails = (thumbnailObjectsArray) => {
    thumbnailObjectsArray.forEach((thumbnailObj) => {
      const imageElement = document.getElementById(thumbnailObj.adId);
      if (imageElement) {
        if (!imageElement.name.includes('DAA')) {
          imageElement.src = thumbnailObj.thumbnail;
        } else {
          imageElement.src = Images.daaType;
        }
      }
    });
  };

  render() {
    const { adsets, ads, adPrototypes } = this.props;
    const {
      showModalAd,
      adToEdit,
      isDAA,
      objective,
      adset,
      possibleAdToRemoveId
    } = this.state;
    return (
      <div>
        {adsets.map((adSet) => (
          <List.Item className="manage-package-ad-container">
            <b>{adSet.adSetName}</b>
            <List.Item className="manage-package-ad-container">
              {ads
                .filter((item) => item.adSetId === adSet.id)
                .map((ad) => {
                  const isAdValid = this.checkValidAd(ad);
                  const { ad: innerAd, name, id } = ad || {};
                  const {
                    id: adId,
                    thumbnail,
                    type,
                    asset_id: assetId,
                    qc_approved: qcApproved
                  } = innerAd || {};
                  return isAdValid ? (
                    <div className="ad-item-container">
                      <a
                        role="button"
                        tabIndex={0}
                        className="ad-item-remove-link"
                        onClick={() => this.toggleRemoveAdFromPackageModal(id)}
                      >
                        <Icon size="large" name="cancel" />
                      </a>
                      {name}
                      <Divider hidden />
                      <Image
                        name={name}
                        id={adId}
                        className="manage-package-ad-preview-image"
                        src={thumbnail}
                      />
                      <div className="manage-package-ad-prototype-field">
                        <span>
                          {!qcApproved ? (
                            <Label color="yellow" size="mini">
                              <Icon color="black" name="warning sign" />
                              Requires QC approval
                            </Label>
                          ) : null}
                        </span>
                        <Divider hidden />
                        <span>
                          <b>
                            {type}{' '}
                            {assetId === 'Still' || assetId === 'Carousel'
                              ? assetId
                              : ''}
                          </b>
                        </span>
                      </div>
                      <div className="ad-item-container-operations">
                        <a
                          role="button"
                          tabIndex={0}
                          className="ad-item-edit-link"
                          onClick={() => this.editAd(ad, adSet.id, adSet)}
                        >
                          <Icon size="large" name="edit" />
                        </a>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <span style={{ color: 'red' }}>
                        • Ad data {ad ? `for ${name}` : ''} cannot be found.
                        Review the ad using Ad Library. Remaking the package may
                        also solve the problem.
                      </span>
                      <Divider hidden />
                      <Button
                        color="blue"
                        onClick={() =>
                          this.openAdModal(adSet.id, ad || null, adSet)
                        }
                      >
                        Replace Ad
                      </Button>
                      <Button
                        color="red"
                        onClick={() => this.toggleRemoveAdFromPackageModal(id)}
                      >
                        Remove Ad
                      </Button>
                      <Divider />
                    </div>
                  );
                })}
            </List.Item>
            <div className="manage-package-ad-link">
              <a
                href="#"
                onClick={() => this.openAdModal(adSet.id, null, adSet)}
              >
                + Add Ad
              </a>
            </div>
          </List.Item>
        ))}
        <Modal
          dimmer={'inverted'}
          open={showModalAd}
          onClose={this.onCloseModalAd}
          size="small"
          className="modal-picker"
        >
          <Modal.Header>
            {!possibleAdToRemoveId ? 'Add Ad' : 'Remove Ad from Package'}
          </Modal.Header>
          {!possibleAdToRemoveId ? (
            <Modal.Content>
              <ModalAd
                onCloseModalAd={this.onCloseModalAd}
                addAd={this.addAd}
                adToEdit={adToEdit}
                adPrototypes={adPrototypes}
                isDAA={isDAA}
                objective={objective}
                adset={adset}
              />
            </Modal.Content>
          ) : (
            <Modal.Content>
              <h4>Are you sure you want to remove this ad from the package?</h4>
            </Modal.Content>
          )}
          {possibleAdToRemoveId ? (
            <Modal.Actions>
              <Button color="green" onClick={this.removeAdFromPackage}>
                Yes
              </Button>
              <Button color="red" onClick={this.onCloseModalAd}>
                No
              </Button>
            </Modal.Actions>
          ) : null}
        </Modal>
      </div>
    );
  }
}

export default AdList;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdList.js